import styled from 'styled-components'
import { Button as AntdButton } from 'antd'

export const Button = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  // gap: 10px;
`
